/**
 * QA Permissions (Frontend)
 * Client-side helpers for UI state only - backend is the source of truth
 */

// Users whose lists are automatically flagged as QA lists
export const QA_USERS = [
  'olha.kushytska@orderfox.com',
];

// Users who can edit QA-flagged lists and their schedules
export const ADMIN_USERS = [
  'olha.kushytska@orderfox.com',
  'a.marti@orderfox.com',
  'p.zeqo@orderfox.com',
];

/**
 * Check if a user is a QA user (lists auto-flagged as isQaList)
 */
export function isQaUser(email?: string | null): boolean {
  if (!email) return false;
  return QA_USERS.includes(email.toLowerCase());
}

/**
 * Check if a user is an admin (can edit QA lists)
 */
export function isAdminUser(email?: string | null): boolean {
  if (!email) return false;
  return ADMIN_USERS.includes(email.toLowerCase());
}

